import {createContext} from 'react'

const CatTipoCompraContext = createContext()

export default CatTipoCompraContext